import React, { useEffect, useMemo } from "react";
import profileimg from "../assets/profile.png";
import editcover from "../assets/images/icons/edit-p.svg";
import camera from "../assets/images/icons/camera.svg";
import profileData from "./feedpost/profiledata";
import { Menu, X, Bell, User, Home } from "lucide-react";
import { useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Select from "react-select";
import countryList from 'react-select-country-list';
import locationicon from "../assets/gps.png"
import { Navigation, Pagination } from "swiper/modules";
import profilebanner from "../assets/images/Profile-banner.png";
import Leftsidebar from "../components/sidebar/leftsidebar"
import LeftResponsivesidebar from "../components/sidebar/left-responsive"
import Rightsidebar from "../components/sidebar/rightsidebar"
import RightResponsivesidebar from "../components/sidebar/right-responsive"
import Headmenu from "../components/sidebar/headmenu"
import Sharepost from "../components/sharepost";
import { useNavigate } from "react-router-dom";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import signupdropdown from "../../src/assets/images/icons/signup-dropdown.svg";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export default function Profileedit() {
    const navigate = useNavigate(); // Initialize navigation
    const postData = [
        {
            intro: "",
        }

    ];
    // ✅ State to store user details
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        date_of_birth: "",
        profile_picture_url: "",
        bio: postData.intro,
        gender: "",
        location: "",
        country: "",
        language: "",
        is_tc_agreed: false,
    });
    const countryOptions = [
        { code: "US", name: "United States", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/us.png" },
        { code: "GB", name: "United Kingdom", dialCode: "+44", flagUrl: "https://flagcdn.com/w40/gb.png" },
        { code: "CA", name: "Canada", dialCode: "+1", flagUrl: "https://flagcdn.com/w40/ca.png" },
        { code: "AU", name: "Australia", dialCode: "+61", flagUrl: "https://flagcdn.com/w40/au.png" },
        { code: "DE", name: "Germany", dialCode: "+49", flagUrl: "https://flagcdn.com/w40/de.png" },
        { code: "FR", name: "France", dialCode: "+33", flagUrl: "https://flagcdn.com/w40/fr.png" },
        { code: "JP", name: "Japan", dialCode: "+81", flagUrl: "https://flagcdn.com/w40/jp.png" },
        { code: "CN", name: "China", dialCode: "+86", flagUrl: "https://flagcdn.com/w40/cn.png" },
        { code: "IN", name: "India", dialCode: "+91", flagUrl: "https://flagcdn.com/w40/in.png" },
        { code: "BR", name: "Brazil", dialCode: "+55", flagUrl: "https://flagcdn.com/w40/br.png" },
    ];
    const [userData, setUserData] = useState(null);

    const [error, setError] = useState(null);
    const [location, setLocation] = useState(null);

    // Uploading states for showing animation while uploading
    const [isUploadingProfile, setIsUploadingProfile] = useState(false);
    const [isUploadingCover, setIsUploadingCover] = useState(false);

    // Name validation errors (live validation)
    const [nameErrors, setNameErrors] = useState({ first_name: "", last_name: "" });
    // ✅ Date of Birth Validation
    const today = new Date(); // Current date
    const minAllowedDate = new Date(); // Initialize minAllowedDate
    minAllowedDate.setFullYear(today.getFullYear() - 13); // Subtract 13 years
    const maxDOB = minAllowedDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    const bioCharCount = formData.bio ? formData.bio.length : 0;

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "56px",
            borderRadius: "20px",
            border: "0.5px solid #095228",
            padding: "5px",
        }),
        control: (base) => ({
            ...base,
            minWidth: 100,
            minHeight: "100%",
            borderRadius: "12px",
            border: "0.5px solid #095228",
            padding: "10px 5px",
        }),
        option: (provided) => ({
            ...provided,
            display: "flex",
            alignItems: "center",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensures it appears on top
    };
    // Carousel login
    let slides = [
        loginbanner,
        loginbannertwo,
        loginbannerthree,
        loginbannerfour
    ];
    let slidessm = [
        loginbannersm,
        loginbannersm,
        loginbannersm,
        loginbannersm,
    ];
    const [selectedMethod, setSelectedMethod] = useState("email"); // Default: email
    const [inputValue, setInputValue] = useState(""); // Store email or phone input
    const API_URL = `${API_BASE_URL}/auth`;
    const languages = ["English", "Spanish", "French", "German", "Chinese"];
    // Generate country list using react-select-country-list (same as signup)
    const countryOptionsList = useMemo(() => countryList().getData(), []);
    const [showOTPModal, setShowOTPModal] = useState(false);
    const [otp, setOtp] = useState("");

    // Function to get user location and convert to address
    const getLocation = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    console.log("Coordinates:", latitude, longitude);

                    try {
                        const response = await fetch(
                            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
                        );
                        const data = await response.json();
                        console.log("Address:", data.display_name);

                        setLocation(data.display_name);
                        setFormData({ ...formData, location: data.display_name });
                    } catch (err) {
                        console.error("Error fetching address:", err);
                        setError("Failed to fetch address.");
                    }
                },
                (err) => {
                    console.error("Geolocation Error:", err);
                    setError("Location access denied. Please enable location services.");
                }
            );
        } else {
            setError("Geolocation is not supported by this browser.");
        }
    };

    // ✅ Fetch user details when the page loads
    useEffect(() => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // ✅ Retrieve token
        if (!token) {
            console.warn("No token found, redirecting...");
            navigate("/login");
            return;
        }
        const fetchUserProfile = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/user/profile`, {
                    method: "GET",
                    headers: {
                        "token": `${token}`,
                        "Content-Type": "application/json",
                    },
                });

                console.log("Profile Fetch API Response Status:", response.status);
                if (!response.ok) {
                    // Save profile picture URL to sessionStorage and state
                    const profilePic = data.result.profile_picture_url;
                    const coverPic = data.result.cover_picture_url;

                    if (profilePic) {
                        sessionStorage.setItem("profilePictureUrl", profilePic);
                        localStorage.setItem("profilePictureUrl", profilePic);
                        setProfilePictureUrl(profilePic);
                    }

                    if (coverPic) {
                        sessionStorage.setItem("cover_picture_url", coverPic);
                        localStorage.setItem("cover_picture_url", coverPic);

                        setCoverPictureUrl(coverPic);
                    }
                    const errorData = await response.json();
                    console.error("❌ Fetch Profile API Error:", errorData);
                    setError(errorData.message || "Failed to load profile.");
                    return;
                }

                const data = await response.json();
                console.log("✅ Profile Fetched Successfully:", data);
                setUserData(data.result); // Set the userData state with the API response

                // ✅ Ensure "id" is not included when setting the form state
                const { id, username, email, mobile_number, ...userDetails } = data.result;

                // ✅ Set `bio` from API data or use `postData[0].intro` as default
                const updatedBio = userDetails.bio || postData[0].intro;
                const updatedDateOfBirth = userDetails.date_of_birth
                    ? new Date(userDetails.date_of_birth).toISOString().split("T")[0]
                    : "";
                const updatedLanguage = userDetails.language || ""; // Default to empty string

                setFormData({
                    ...userDetails, bio: updatedBio,
                    date_of_birth: updatedDateOfBirth,
                    language: updatedLanguage,
                });
            } catch (err) {
                console.error("❌ API Request Failed:", err);
                setError("An error occurred while fetching the profile.");
            }
        };

        fetchUserProfile();
    }, []);
    // Add new state variables
    const [coverPictureUrl, setCoverPictureUrl] = useState(() => {
        return sessionStorage.getItem("cover_picture_url") || profilebanner;
    });
    const [locationLatitude, setLocationLatitude] = useState("");
    const [locationLongitude, setLocationLongitude] = useState("");
    const [uploadedMedia, setUploadedMedia] = useState([]);
    const [profilePictureUrl, setProfilePictureUrl] = useState(() => {
        return sessionStorage.getItem("profilePictureUrl") || profileimg;
    });

    // Update the handleImageChange function
    // const handleImageChange = async (event, type) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         try {
    //             // Upload the file to S3 and get the uploaded URL
    //             const uploadedMedia = await uploadFiles([file]); // Pass the file as an array
    //             const uploadedUrl = uploadedMedia[0]?.url; // Get the first uploaded file's URL

    //             if (type === "profile_picture_url") {
    //                 setProfilePictureUrl(uploadedUrl); // Update profile picture URL
    //                 setFormData({ ...formData, profile_picture_url: uploadedUrl });
    //             } else if (type === "cover_picture_url") {
    //                 setCoverPictureUrl(uploadedUrl); // Update cover picture URL
    //             }
    //         } catch (error) {
    //             console.error("Image Upload Error:", error);
    //             setError("Failed to upload image. Please try again.");
    //         }
    //     }
    // };


    // Function to handle image change and upload to S3
    const handleImageChange = async (event, type) => {
        const file = event.target.files[0];
        if (file) {
            // Prevent starting another upload if one is in progress for the same type
            if ((type === "profile_picture_url" && isUploadingProfile) || (type === "cover_picture_url" && isUploadingCover)) return;

            try {
                // set uploading state
                if (type === "profile_picture_url") setIsUploadingProfile(true);
                if (type === "cover_picture_url") setIsUploadingCover(true);

                // Step 1: Generate Pre-Signed URL
                console.log(`Uploading ${type}...`, file);

                const response = await axios.post(
                    `${API_BASE_URL}/aws/generate-presigned-url`,
                    { files: [{ fileName: file.name, fileType: file.type }] },
                    {
                        headers: {
                            'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
                        },
                    }
                );
                console.log("Pre-Signed URL Response:", response.data);

                if (!response.data.success) {
                    throw new Error('Failed to generate pre-signed URL');
                }

                const { presignedUrl, fileUrl } = response.data.directory[0];

                // Step 2: Upload the file to S3
                await axios.put(presignedUrl, file, {
                    headers: {
                        'Content-Type': file.type,
                        'Content-Encoding': 'binary',
                    },
                });

                console.log(`${file.name} uploaded successfully to ${fileUrl}`);

                // Step 3: Update the state with the uploaded URL
                if (type === "profile_picture_url") {
                    setProfilePictureUrl(fileUrl);
                    setFormData({ ...formData, profile_picture_url: fileUrl });
                    sessionStorage.setItem("profilePictureUrl", fileUrl);
                    localStorage.setItem("profilePictureUrl", fileUrl);

                } else if (type === "cover_picture_url") {
                    setCoverPictureUrl(fileUrl);
                    sessionStorage.setItem("cover_picture_url", fileUrl);
                    localStorage.setItem("cover_picture_url", fileUrl);

                }
            } catch (error) {
                console.error("Image Upload Error:", error);
                setError("Failed to upload image. Please try again.");
            } finally {
                if (type === "profile_picture_url") setIsUploadingProfile(false);
                if (type === "cover_picture_url") setIsUploadingCover(false);
            }
        }
    };
    // Upload files function with pre-signed URL generation and S3 upload
    const uploadFiles = async () => {
        if (!uploadedMedia || uploadedMedia.length === 0) {
            alert("Please select files");
            return [];
        }

        const fileData = uploadedMedia.map((media) => ({
            fileName: media.file.name,
            fileType: media.file.type
        }));

        try {
            // Step 1: Generate pre-signed URLs
            const response = await axios.post(
                `${API_BASE_URL}/aws/generate-presigned-url`,
                { files: fileData },
                {
                    headers: {
                        'token': sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken")
                    }
                }
            );

            if (!response.data.success) {
                throw new Error('Failed to generate pre-signed URLs');
            }

            const preSignedUrls = response.data.directory;

            // Step 2: Upload media files to S3
            await Promise.all(
                preSignedUrls.map(async (item, index) => {
                    await axios.put(item.presignedUrl, uploadedMedia[index].file, {
                        headers: {
                            'Content-Type': uploadedMedia[index].file.type,
                            'Content-Encoding': 'binary'
                        }
                    });
                    console.log(`${item.fileName} uploaded successfully`);
                })
            );

            return preSignedUrls.map(item => ({
                media_type: item.fileType.startsWith("image") ? "image" : "video",
                url: item.fileUrl // Extract fileUrl from API response
            }));

        } catch (error) {
            console.error('Upload error:', error);
            setError('Failed to upload files. Please try again.');
            throw new Error('Failed to upload files');
        }
    };

    // Clean up preview URLs when component unmounts
    useEffect(() => {
        return () => {
            uploadedMedia.forEach(media => {
                URL.revokeObjectURL(media.url);
            });
        };
    }, [uploadedMedia]);

    // ✅ Submit Edited Details
    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // ✅ Get token
        const formattedMobile = `${formData.countryCode}-${formData.mobile}`;

        if (!token) {
            setError("Authentication token not found!");
            return;
        }



        let newErrors = {};

        // ✅ Validate first & last name
        const namePattern = /^[A-Za-z\s]+$/;
        if (!formData.first_name || !formData.first_name.trim()) {
            newErrors.first_name = "First name is required.";
        } else if (formData.first_name.length > 30) {
            newErrors.first_name = "First name cannot exceed 30 characters.";
        } else if (!namePattern.test(formData.first_name)) {
            newErrors.first_name = "First name can only contain letters and spaces.";
        }

        if (!formData.last_name || !formData.last_name.trim()) {
            newErrors.last_name = "Last name is required.";
        } else if (formData.last_name.length > 30) {
            newErrors.last_name = "Last name cannot exceed 30 characters.";
        } else if (!namePattern.test(formData.last_name)) {
            newErrors.last_name = "Last name can only contain letters and spaces.";
        }

        // ✅ Check for future dates or under 13 years old
        const dobDate = new Date(formData.date_of_birth);

        if (!formData.date_of_birth.trim()) {
            newErrors.date_of_birth = "Date of birth is required.";
        } else if (dobDate > today) {
            newErrors.date_of_birth = "Future dates are not allowed.";
            alert("❌ Future dates are not allowed.");
        } else if (dobDate > minAllowedDate) {
            newErrors.date_of_birth = "You must be at least 13 years old to update your profile.";

            // ✅ Show both toast and alert for under 13 users
            alert("❌ You must be at least 13 years old to update your profile.");
            toast.error("⚠️ You must be at least 13 years old to update your profile.", {
                position: "top-right",
                autoClose: 3000,
                style: { backgroundColor: "#ff4d4f", color: "#fff", fontWeight: "bold" }
            });

            setError("You must be at least 13 years old.");
            return;  // ✅ Prevent submission
        }

        // ✅ Set the validation errors
        setError(newErrors);

        // ✅ Stop submission if there are validation errors
        if (Object.keys(newErrors).length > 0) {
            console.log("Profile update blocked due to validation errors.");
            return;
        }

        // Construct the request body
        // ✅ Construct request data
        const requestData = {
            first_name: formData.first_name,
            last_name: formData.last_name,
            date_of_birth: formData.date_of_birth,
            profile_picture_url: formData.profile_picture_url,
            cover_picture_url: coverPictureUrl, bio: formData.bio,
            gender: formData.gender,
            privacy_status: "public", // Default privacy status
            locationLatitude: locationLatitude,
            locationLongitude: locationLongitude,

            location: formData.location,
            country: formData.country,
            language: formData.language,
            is_tc_agreed: formData.is_tc_agreed,
        };
        try {
            const response = await fetch(`${API_BASE_URL}/user/add-edit-details`, {
                method: "POST", // ✅ Ensure correct method
                headers: {
                    "token": `${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData), // ✅ Send updated user data
            });

            console.log("Edit Profile API Response:", response.status);

            if (response.ok) {
                const result = await response.json();
                console.log("✅ Profile Updated:", result);
                // ✅ Update the bio in the frontend with the new value
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    bio: result.result.bio, // ✅ Update frontend with new API response
                }));
                navigate("/myprofile"); // ✅ Redirect to profile page after success
            } else {
                const errorData = await response.json();
                console.error("❌ Edit Profile API Error:", errorData);
                setError(errorData.message || "Failed to update profile.");
            }
        } catch (error) {
            console.error("❌ API Request Failed:", error);
            setError("An error occurred while updating the profile.");
            toast.error("🚫 Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
                style: { backgroundColor: "#ff4d4f", color: "#fff" }
            });
        }
    };
    const handleCountryChange = (selectedOption) => {
        setFormData((prevState) => ({
            ...prevState,
            countryCode: selectedOption.dialCode, // Update the country code
        }));
    };

    // ✅ Handle Name Input Changes with validation (letters and spaces only, max 30)
    const handleNameChange = (field, value) => {
        // Remove invalid characters (only letters and spaces allowed)
        const sanitized = value.replace(/[^A-Za-z\s]/g, "");
        const truncated = sanitized.slice(0, 30);

        // Live validation messages
        const err = { ...nameErrors };
        if (!truncated.trim()) {
            err[field] = `${field === 'first_name' ? 'First' : 'Last'} name is required.`;
        } else if (truncated.length > 30) {
            err[field] = `${field === 'first_name' ? 'First' : 'Last'} name cannot exceed 30 characters.`;
        } else if (!/^[A-Za-z\s]+$/.test(truncated)) {
            err[field] = `${field === 'first_name' ? 'First' : 'Last'} name can only contain letters and spaces.`;
        } else {
            err[field] = "";
        }

        setNameErrors(err);
        setFormData({ ...formData, [field]: truncated });
    };

    // ✅ Handle Input Changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };




    return (
        <div className="dashboard w-full min-h-screen  flex">
            {/* Sidebar */}
            <Leftsidebar />
            <main className="flex-1 p-6 pl-8">
                <LeftResponsivesidebar />
                <Headmenu />
                {/* Main Content */}
                <main className="block md:grid md:grid-cols-[78%_20%]">
                    {/* Feeds */}
                    <div className="flex-1 lg:pr-5 space-y-6">
                        <div className="profile-content ">
                            <div className="relative w-full">
                                {/* Cover Photo */}
                                <img
                                    src={coverPictureUrl || profilebanner} // Use uploaded cover photo or fallback

                                    alt="profilebanner" className="w-full object-cover max-h-[300px] rounded-xl" />
                                {/* Edit Button */}
                                <label className="edit-cover absolute top-0 right-12 bg-[#FFFFFF80] bg-opacity-50 text-[#161F28] px-4 py-2 text-sm flex items-center space-x-2 hover:bg-opacity-75 transition">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        disabled={isUploadingCover}
                                        onLoad={() => console.log("Cover Image Loaded:", coverPictureUrl)}
                                        onError={() => console.error("Failed to load cover image:", coverPictureUrl)}
                                        onChange={(e) => handleImageChange(e, "cover_picture_url")}
                                    />
                                    <img src={editcover} alt="edit" className="w-4 h-4" />
                                    <span>Edit Cover</span>
                                </label>
                                {isUploadingCover && (
                                    <div className="absolute inset-0 flex items-center justify-center bg-black/30 z-10">
                                        <div className="w-10 h-10 border-4 border-t-transparent border-white rounded-full animate-spin" />
                                    </div>
                                )}
                            </div>
                            {profileData.map((post, index) => {
                                // const maxLength = 150; 
                                // const isExpanded = expandedPosts[index];

                                return (
                                    <div className=" space-y-3 mt-7 profile-body-profile-edit relative">
                                        <div className="flex items-end relative left-5">
                                            <div className="profile-dashboard profile-page-dashboard overflow-hidden relative">
                                                {/* Profile Image Upload */}
                                                <label className="relative cursor-pointer">
                                                    <input type="file" accept="image/*" className="hidden" disabled={isUploadingProfile} onChange={(e) => handleImageChange(e, "profile_picture_url")} />
                                                    <img
                                                        src={profilePictureUrl || profileimg} // Use uploaded profile picture or fallback
                                                        alt="Profile"
                                                        onLoad={() => console.log("Profile Image Loaded:", profilePictureUrl)}
                                                        onError={() => console.error("Failed to load profile image:", profilePictureUrl)}

                                                        className="w-full h-full object-cover"
                                                    />
                                                    {/* Upload spinner overlay when uploading profile image */}
                                                    {isUploadingProfile && (
                                                        <div className="absolute inset-0 flex items-center justify-center bg-black/30 z-10">
                                                            <div className="w-8 h-8 border-4 border-t-transparent border-white rounded-full  animate-spin" />
                                                        </div>
                                                    )}
                                                    {/* Camera Icon Overlay */}
                                                    <div className="absolute">
                                                        <img src={camera} alt="Edit" className=" text-white" />
                                                    </div>
                                                </label>
                                            </div>
                                            <div className="feed-title pl-4 relative">
                                                <p className="font-semibold text-[20px]">{userData?.first_name} {userData?.last_name || "N/A"}</p>
                                                <p className="text-sm text-[#747474]">@{userData?.username || "N/A"}</p>
                                                {/* <p className="text-sm text-[#747474]">{userData?.followersCount || 0} Followers</p> */}

                                                <p className="flex text-sm text-[#747474]">
                                                    <span className="flex items-center followers-profile ml-1 cursor-pointer">
                                                        {/* Follower Images */}
                                                        {post.followerImages?.slice(0, 4).map((img, index) => (
                                                            <img
                                                                key={index}
                                                                src={img}
                                                                alt={`Follower ${index + 1}`}
                                                                className="w-6 h-6 rounded-full border-2 border-white -ml-2 first:ml-0"
                                                            />
                                                        ))}
                                                        {/* Follower Count */}
                                                        <span className="ml-2">{userData?.mutualFollowersCount} Followers</span>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="user-intro-profile-edit">
                                            <div className="user-intro-flex  my-5">
                                                {/* Login form */}
                                                <div className="w-full space-y-6 ">
                                                    <div className="space-y-4 signup-scroll signup-scroll-profile-edit">
                                                        <div className="bio-container relative space-y-2">
                                                            <label className="text-sm font-medium" htmlFor="bio">
                                                                Enter your Intro/Bio
                                                            </label>

                                                            <textarea
                                                                id="bio"
                                                                name="bio"
                                                                value={formData.bio}
                                                                onChange={handleChange}
                                                                maxLength={250}
                                                                className="rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-black"
                                                            />

                                                            <p id="char-count" className="absolute">
                                                                {bioCharCount}/250 Characters
                                                            </p>
                                                        </div>


                                                        <div className="bio-container space-y-2" >
                                                            <label className="text-sm font-medium  -top-[35px] " htmlFor="first_name">
                                                                First Name
                                                            </label>
                                                            <input
                                                                // id="first_name"
                                                                placeholder="Enter your First Name"
                                                                type="text"
                                                                name="first_name"
                                                                maxLength={30}
                                                                value={formData.first_name}
                                                                onChange={(e) => handleNameChange('first_name', e.target.value)}
                                                                className={`w-[400px] h-[60px] px-3 py-2 border ${(nameErrors.first_name || error?.first_name) ? 'border-red-500' : 'border-gray-400'} rounded-[12px] focus:outline-none focus:ring focus:ring-[#00000014]`}
                                                            />
                                                            {(nameErrors.first_name || error?.first_name) && (
                                                                <p className="text-red-500 text-sm">{nameErrors.first_name || error?.first_name}</p>
                                                            )}
                                                        </div>
                                                        <div className="bio-container space-y-2" >
                                                            <label className="text-sm font-medium" htmlFor="last_name">
                                                                Last Name
                                                            </label>
                                                            <input
                                                                // id="last_name"
                                                                placeholder="Enter your Last Name"
                                                                type="text"
                                                                name="last_name"
                                                                maxLength={30}
                                                                value={formData.last_name}
                                                                onChange={(e) => handleNameChange('last_name', e.target.value)}
                                                                className={`w-[400px] h-[60px] px-3 py-2 border ${(nameErrors.last_name || error?.last_name) ? 'border-red-500' : 'border-gray-400'} rounded-[12px] focus:outline-none focus:ring focus:ring-[#00000014]`}
                                                            />
                                                            {(nameErrors.last_name || error?.last_name) && (
                                                                <p className="text-red-500 text-sm">{nameErrors.last_name || error?.last_name}</p>
                                                            )}
                                                        </div>
                                                        {/* <div className="bio-container space-y-2" >
                                                            <label className="text-sm font-medium  -top-[35px] " htmlFor="user_name">
                                                                User Name
                                                            </label>
                                                            <input
                                                                // id="first_name"
                                                                placeholder="Enter your User Name"
                                                                type="text"
                                                                name="user_name"
                                                                maxLength={30}
                                                                value={formData.username}
                                                                onChange={(e) => handleNameChange('username', e.target.value)}
                                                                className={`w-[400px] h-[60px] px-3 py-2 border ${(nameErrors.username || error?.username) ? 'border-red-500' : 'border-gray-400'} rounded-[12px] focus:outline-none focus:ring focus:ring-[#00000014]`}
                                                            />
                                                            {(nameErrors.username|| error?.username) && (
                                                                <p className="text-red-500 text-sm">{nameErrors.username || error?.username}</p>
                                                            )}
                                                        </div> */}
                                                        <div className="space-y-2 bio-container" >
                                                            <label className="text-sm font-medium" htmlFor="date_of_birth">
                                                                Date of Birth
                                                            </label>
                                                            <input
                                                                // id="dob"
                                                                placeholder="DD/MM/YY"
                                                                type="date"
                                                                name="date_of_birth"
                                                                value={formData.date_of_birth}
                                                                onChange={handleChange}
                                                                max={maxDOB} // Set the maximum allowable date
                                                                className={`w-[400px] h-[60px] px-3 py-2 border ${error?.date_of_birth ? "border-red-500" : "border-gray-400"
                                                                    } rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-[#000000]`}

                                                            // className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-[#000000]"
                                                            />
                                                            {error?.date_of_birth && (
                                                                <p className="text-red-500 text-sm">{error.date_of_birth}</p>
                                                            )}
                                                        </div>

                                                        {/* <div className="bio-container space-y-2" >
                                                            <label className="text-sm font-medium" htmlFor="location">
                                                                Location
                                                            </label>
                                                            <input
                                                                id="location"
                                                                placeholder="Add your Location"
                                                                type="location"
                                                                name="location"
                                                                value={formData.location}
                                                                onChange={handleChange}
                                                                onClick={getLocation}
                                                                readOnly
                                                                className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-[#000000]"
                                                            />

                                                            <img
                                                                src={locationicon} // Make sure to use the correct image path
                                                                alt="Location"
                                                                className="  transform -translate-y-1/2 w-6 h-6"
                                                            />

                                                        </div> */}

                                                        <div className="bio-container space-y-2">
                                                            <label className="text-sm font-medium" htmlFor="location">
                                                                Location
                                                            </label>

                                                            <div className="relative">
                                                                <input
                                                                    id="location"
                                                                    placeholder="Add your Location"
                                                                    type="location"
                                                                    name="location"
                                                                    value={formData.location}
                                                                    onChange={handleChange}
                                                                    onClick={getLocation}
                                                                    readOnly
                                                                    className="w-full h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-[#000000] pr-12"
                                                                />

                                                                {/* Location Icon Inside the Input Field */}
                                                                <img
                                                                    src={locationicon}
                                                                    alt="Location"
                                                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 w-6 h-6"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="space-y-2 relative bio-container">
                                                            <div>
                                                                <label className="text-sm font-medium" htmlFor="country">
                                                                    Country Of Origin</label>
                                                            </div>
                                                            <div className="relative">
                                                                <Select
                                                                    options={countryOptionsList}
                                                                    value={countryOptionsList.find(o => o.label === formData.country) || null}
                                                                    onChange={(selected) => setFormData(prev => ({ ...prev, country: selected?.label || '' }))}
                                                                    styles={customStyles}
                                                                    menuPortalTarget={document.body}
                                                                    placeholder="Select Your Country"
                                                                    isClearable
                                                                />
                                                                {/* Custom dropdown arrow (decorative) */}
                                                                <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-500">
                                                                    <img src={signupdropdown} alt="Taken" className="" />
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {/* <div className="space-y-2 bio-container">
                                                            <div>
                                                                <label className="text-sm font-medium" htmlFor="language">
                                                                    Language</label>
                                                            </div>
                                                            <select
                                                                name="language"
                                                                className="h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-[#000000]"
                                                                onChange={handleChange}
                                                                value={formData.language}
                                                                required
                                                            >
                                                                <option value="">Select your Language</option>
                                                                {languages.map((lang) => (
                                                                    <option key={lang} value={lang}>
                                                                        {lang}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div> */}
                                                        {/* Phone Number Input */}
                                                        {/* <div className="space-y-2 bio-container">
                                                            <label className="text-sm font-medium" htmlFor="mobile">
                                                                Mobile Number
                                                            </label>
                                                            <div className="flex space-x-2 items-center">
                                                                <Select
                                                                    options={countryOptions}
                                                                    getOptionLabel={(e) => (
                                                                        <div className="flex items-center">
                                                                            <img src={e.flagUrl} alt="" className="w-6 h-4" />
                                                                            <span className="ml-2 hidden">{e.dialCode}</span>
                                                                        </div>
                                                                    )}
                                                                    getOptionValue={(e) => e.dialCode}
                                                                    value={countryOptions.find((c) => c.dialCode === formData.countryCode)}
                                                                    onChange={handleCountryChange}
                                                                    styles={customStyles}
                                                                    menuPortalTarget={document.body} // Ensures popup behavior
                                                                    menuPosition="absolute"
                                                                />
                                                                <input
                                                                    placeholder="Phone Number"
                                                                    type="tel"
                                                                    name="mobile"
                                                                    value={formData.mobile}
                                                                    onChange={handleChange}
                                                                    className="w-[300px] h-[56px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-[#000000]"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="bio-container space-y-2" >
                                                            <label className="text-sm font-medium  -top-[35px] " htmlFor="email">
                                                                Email
                                                            </label>
                                                            <input
                                                                placeholder="Enter your Mail ID"
                                                                type="email"
                                                                name="email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                                className="w-[400px] h-[60px] px-3 py-2 border border-gray-400 rounded-[12px] focus:outline-none focus:ring focus:ring-blue-200 text-[#000000]"
                                                            />
                                                        </div> */}
                                                    </div>
                                                    <div className="text-center bio-container">
                                                        <button
                                                            onClick={handleSubmit}
                                                            className="creat-account-cta w-[100%] h-[56px] bg-[#1B2537] hover:bg-[#1B2537]/90 text-white py-3 rounded-[15px]"
                                                        >
                                                            Update Profile
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <Rightsidebar />
                </main>
            </main>
        </div >
    );
}
